import { MouseEventHandler } from "react";
import "./hours-calendar.scss";

export interface SpringshareHoursCalendarProps {
  title: string;
  tableHTML: string;
  onClickPrevious?: MouseEventHandler;
  onClickNext?: MouseEventHandler;
}

export function SpringshareHoursCalendar({
  title,
  tableHTML,
  onClickPrevious,
  onClickNext,
}: SpringshareHoursCalendarProps) {
  return (
    <div
      className="hbs-global-align-wide hbs-hours-calendar"
      data-theme={"white"}
    >
      <div className="hbs-hours-calendar-header">
        <h2 className="hbs-text-h4">{title}</h2>
        <div>
          <button
            className="btn"
            aria-label="Previous"
            onClick={onClickPrevious}
          >
            Previous
          </button>
          <button className="btn" aria-label="Next" onClick={onClickNext}>
            Next
          </button>
        </div>
      </div>
      {tableHTML && <div dangerouslySetInnerHTML={{ __html: tableHTML }}></div>}
    </div>
  );
}
